import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Facebook from "../../assets/logo/facebook.svg";
// import Instagram from "../../assets/logo/instagram-icon.svg";
// import DownloadReportIcon from "../../assets/dasboard/download-report-image.svg";
import linkIcon from "../../assets/dasboard/link-icon.svg";
import copyIcon from "../../assets/dasboard/copy-icon.svg";
import congratsImg from "../../assets/checkout/congrats-img.png";
// import copyIconHover from "../../assets/dasboard/copy-icon-hover.svg";
import {
  AssessmentForSamePersonalityNameAndRole,
  AssessmentForLongText,
  getColorCode,
  REPORT_ROUTES,
  convertToLowerCase,
  addSpacesOnCaps,
  SOCAIL_BUTTON,
} from "../../utils/utility-functions";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import { ROUTE_CONSTANT } from "../../routing/route-constants";
import PathHelper from "../../utils/path-helper";
import { useParams } from "react-router-dom";
import { LOCALE } from "../../utils/constants";
import { useTranslation } from "react-i18next";
import { ENNEAGRAM_TEST_ASSESSMENT_ID } from "../../utils/general-config";

const ShareProfileModal = ({
  isOpen,
  onClose,
  personalityImage,
  assessmentTitle,
  assessmentAttemptId,
  personalityType,
  personalityName,
  personalityGroup,
  userGUID,
  assessmentId,
  isRomanticCompatibility,
  assessmentAttemptResultId,
  saveUserSocialButtonClickConnect,
  isFreeUpgrade = false,
  onInviteFriendsClick,
  isDeleteConfirm = false,
  onConfirmDelete,
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const { t } = useTranslation();
  const isEnneagramTest =
    convertToLowerCase(assessmentId) ===
    convertToLowerCase(ENNEAGRAM_TEST_ASSESSMENT_ID);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!isOpen) return null;

  /* DELETE CONFIRMATION MODAL */

  if (isDeleteConfirm) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-3">
        <div className="w-full max-w-[420px] bg-white rounded-2xl shadow-xl p-6 flex flex-col items-center text-center gap-2">
          {/* TOP ROW - CLOSE BUTTON */}
          <div className="w-full flex justify-end">
            <button
              id="filter-tests-sidepanel-button"
              className="flex items-center px-4 py-1 rounded-full text-white text-sm font-medium hover:opacity-90 transition"
              style={{ backgroundColor: "#805AED" }}
              onClick={onClose}
            >
              {t("dashboard.close_button")}
              <span className="text-[20px] ml-1">&times;</span>
            </button>
          </div>
          <h2 className="text-xl md:text-2xl font-semibold text-[#444c5e]">
            {t("dashboard-b.delete_popup.sure")}
          </h2>

          <p className="text-[#444c5e] text-base md:text-lg font-medium">
            {t("dashboard-b.delete_popup.delete_report")}
          </p>

          <div className="flex gap-4 mt-2">
            <button
              onClick={onConfirmDelete}
              className="px-6 py-2 rounded-full bg-insightful-orange text-white font-semibold hover:bg-red-600 transition"
            >
              {t("dashboard-b.delete_popup.yes_btn")}
            </button>

            <button
              onClick={onClose}
              className="px-6 py-2 rounded-full bg-gray-200 text-gray-800 font-semibold hover:bg-gray-300 transition"
            >
              {t("dashboard-b.delete_popup.no_btn")}
            </button>
          </div>
        </div>
      </div>
    );
  }

  // FREE UPGRADE MODAL (EARLY RETURN)

  if (isFreeUpgrade) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-3">
        <div className="w-full max-w-[860px] bg-[#F2F2F2] rounded-2xl shadow-xl p-5 sm:p-7 md:p-8 flex flex-col gap-6">
          {/* TOP ROW - CLOSE BUTTON */}
          <div className="w-full flex justify-end">
            <button
              id="filter-tests-sidepanel-button"
              className="flex items-center px-4 py-1.5 rounded-full text-white text-sm font-medium hover:opacity-90 transition"
              style={{ backgroundColor: "#805AED" }}
              onClick={onClose}
            >
              {t("dashboard.close_button")}
              <span className="text-[20px] ml-1">&times;</span>
            </button>
          </div>

          {/* CONTENT SECTION */}
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
            {/* LEFT COLUMN */}
            <div className="flex flex-col gap-4 sm:gap-5 text-center md:text-left md:flex-1">
              {/* HEADING */}
              <h2 className="font-semibold text-[#4B5563] leading-tight text-[20px] sm:text-[22px] md:text-[26px]">
                {t("dashboard-b.congratulations_modal.congratulations")}
                <br />
                <span className="text-insightful-purple">
                  {t("dashboard-b.congratulations_modal.free_upgrade")}
                </span>{" "}
                {t("dashboard-b.congratulations_modal.unlocked")}
              </h2>

              {/* IMAGE ONLY FOR MOBILE */}
              <div className="md:hidden flex justify-center">
                <img
                  src={congratsImg}
                  alt="free upgrade"
                  className="w-[55%] max-w-[180px] sm:max-w-[220px] md:max-w-[260px] lg:max-w-[300px] h-auto object-contain mx-auto"
                />
              </div>

              {/* DESCRIPTION */}
              <p className="text-black font-medium leading-relaxed text-[14px] sm:text-[16px] md:text-[18px]">
                {t("dashboard-b.congratulations_modal.description")}
              </p>

              {/* INVITE BUTTON */}
              <button
                onClick={onInviteFriendsClick}
                className="mx-auto md:mx-0 w-full sm:w-fit px-8 sm:px-10 py-3 sm:py-4 rounded-full text-white font-semibold text-[16px] sm:text-[20px] bg-gradient-to-r from-[#7C5CF6] to-[#6C63FF] shadow-md hover:opacity-90 transition"
              >
                {t("dashboard-b.friends.btn")}
              </button>
            </div>

            {/* RIGHT IMAGE (Desktop Only) */}
            <div className="hidden md:flex md:flex-1 items-center justify-center">
              <img
                src={congratsImg}
                alt="free upgrade"
                className="w-[260px] lg:w-[300px] h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Resolve report route token from assessmentId (simple, similar to earlier)
  const assessmentIDValue = assessmentId?.toLowerCase?.();
  const entry = REPORT_ROUTES[assessmentIDValue];
  const reportRoute =
    typeof entry === "object"
      ? isRomanticCompatibility
        ? entry?.compatibility
        : entry?.personal
      : entry || ROUTE_CONSTANT.DEFAULT_REPORT;

  const path = PathHelper(reportRoute, currentLocale);

  const baseUrl = window.location.origin;
  const shareableLink = isRomanticCompatibility
    ? `${baseUrl}${path.next}?assessresid=${assessmentAttemptResultId}`
    : `${baseUrl}${path.next}?aai=${assessmentAttemptId}&uid=${userGUID}`;

  const TestshareableLink = shareableLink;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareableLink);
      toast.success(t("shareModal.link_copied"), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      console.error("Failed to copy:", err);
      toast.error(t("shareModal.failed_copy_link"));
    }
  };

  const handleSocialButtonClick = async (buttonId) => {
    try {
      const payload = {
        userId: userGUID,
        buttonId: buttonId,
        clickCount: 1,
      };
      await saveUserSocialButtonClickConnect(payload);
    } catch (err) {
      console.error("Failed to track social button click:", err);
    }
  };

  if (!isOpen) return null;

  const personalityColorDark = getColorCode(personalityGroup)?.dark;
  const personalityColorLight = getColorCode(personalityGroup)?.light;
  const personalityColorMedium = getColorCode(personalityGroup)?.medium;

  const isSamePersonalityAssessment =
    AssessmentForSamePersonalityNameAndRole.includes(assessmentId);

  const isLongTextAssessment = AssessmentForLongText.includes(assessmentId);
  const isSpanishLocale = currentLocale === LOCALE.ES;

  // Use short versions for Spanish locale and long text assessments
  const useShortText = isSpanishLocale && isLongTextAssessment;

  const shareTextForSamePersonalityNameAndRole = `${t(
    useShortText ? "shareModal.i_just_took_short" : "shareModal.i_just_took",
  )} ${assessmentTitle} ${t(
    useShortText ? "shareModal.found_out_short" : "shareModal.found_out",
  )} ${t("shareModal.my_result")} ${t(
    useShortText ? "shareModal.whats_your_short" : "shareModal.whats_your",
  )}`;

  const shareTextForDifferentPersonalityNameAndRole = `${t(
    useShortText ? "shareModal.i_just_took_short" : "shareModal.i_just_took",
  )} ${assessmentTitle} ${t(
    useShortText
      ? "shareModal.found_out_i_am_short"
      : "shareModal.found_out_i_am",
  )} ${
    isEnneagramTest
      ? addSpacesOnCaps(personalityName)
      : `${personalityName} (${personalityType})`
  }. ${t(
    useShortText ? "shareModal.whats_your_short" : "shareModal.whats_your",
  )}`;

  const shareText = isSamePersonalityAssessment
    ? shareTextForSamePersonalityNameAndRole
    : shareTextForDifferentPersonalityNameAndRole;

  return (
    <>
      <div
        id="share-modal-overlay"
        className="fixed inset-0 top-10 bg-black bg-opacity-50 z-50"
        onClick={onClose}
      />
      <div
        id="share-modal-container"
        className={`fixed transform bg-white shadow z-[1000] overflow-y-auto lg:overflow-hidden
       ${
         isMobile
           ? "bottom-0 left-0 right-0 top-1/5 flex-col items-center rounded-t-[20px]"
           : "left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-[35px]"
       }
       w-full lg:max-w-max justify-center flex d:max-w-4xl 
        md:h-max p-[10px]`}
      >
        <div
          className="flex flex-col p-4 sm:p-6 bottom-0 max-w-max"
          id="share-modal-content"
        >
          {/* Header with Close Button */}
          <div
            className="flex justify-end mb-2 md:mb-4 flex-shrink-0"
            id="share-modal-header"
          >
            <button
              id="share-modal-close-button"
              onClick={onClose}
              style={{
                color: "white",
                backgroundColor: "#805AED",
              }}
              className="py-1 px-2 flex items-center text-base rounded-full transition-colors duration-200"
              onMouseEnter={(e) => (
                (e.currentTarget.style.backgroundColor = personalityColorDark),
                (e.currentTarget.style.color = "white")
              )}
              onMouseLeave={(e) => (
                (e.currentTarget.style.backgroundColor = personalityColorLight),
                (e.currentTarget.style.color = personalityColorDark)
              )}
            >
              {t("shareModal.close")}{" "}
              <span className="text-2xl ml-1">&times;</span>
            </button>
          </div>

          {/* Main Content */}
          <div
            className="flex flex-col md:flex-row-reverse gap-[10px] justify-between overflow-y-auto items-center px-10"
            id="share-modal-main-content"
          >
            {/* Left Side Avatar */}
            <div
              className="flex justify-center flex-shrink-0 w-full md:w-1/3 h-auto max-h-[200px] md:max-h-none"
              id="share-modal-avatar-section"
            >
              <div
                className="aspect-square h-auto max-h-[200px] md:max-h-none"
                id="share-modal-avatar-container"
              >
                <img
                  id="share-modal-personality-image"
                  src={personalityImage}
                  alt="Personality Avatar"
                  className="w-full max-w-[300px] h-auto rounded-full object-contain"
                />
              </div>
            </div>

            {/* Right Side Content */}
            <div className="flex flex-col" id="share-modal-text-content">
              {/* Header Text */}
              <div
                className="max-w-[500px] w-full font-['Montserrat']"
                id="share-modal-title-section"
              >
                <h1
                  className="text-xl sm:text-2xl md:text-4xl font-bold text-center md:text-left"
                  id="share-modal-main-title"
                >
                  <span className="text-[#444c5e]" id="share-modal-title-text">
                    {t("shareModal.share_results_label")}{" "}
                  </span>
                  <span
                    style={{ color: personalityColorMedium }}
                    id="share-modal-friend-text"
                  >
                    {" "}
                    {t("shareModal.friend_text")}
                  </span>
                </h1>
              </div>

              {/* Subheader */}
              <div
                className="max-w-[500px] w-full mt-2 md:mt-4 font-['Montserrat'] text-sm sm:text-base md:text-xl text-center md:text-left"
                id="share-modal-subtitle-section"
              >
                <p id="share-modal-description">
                  <span
                    className="text-[#444c5e] font-medium"
                    id="share-modal-description-text"
                  >
                    {t("shareModal.share_result_description")}{" "}
                  </span>
                  <span
                    style={{ color: personalityColorMedium }}
                    className="font-bold"
                    id="share-modal-assessment-title"
                  >
                    {""} {assessmentTitle}
                  </span>
                  <span
                    className="text-[#444c5e] font-medium"
                    id="share-modal-description-end"
                  >
                    .
                  </span>
                </p>
              </div>

              {/* Social Buttons */}
              <div
                className="flex justify-center md:justify-start gap-4 mt-4 md:mt-6"
                id="share-modal-social-buttons"
              >
                {/* <button
                  onClick={handleFacebookShare}
                  className="aspect-square w-14 sm:w-16 md:w-24 bg-[#d9d9d9] rounded-full flex items-center justify-center hover:bg-gray-300"
                >
                  <img src={Facebook} alt="Facebook" className="w-1/2 h-1/2" />
                </button> */}
                <FacebookShareButton
                  url={TestshareableLink}
                  // quote={description}
                  hashtag={shareText}
                  id="share-modal-facebook-share"
                  onClick={() =>
                    handleSocialButtonClick(SOCAIL_BUTTON.Facebook)
                  }
                >
                  <button
                    id="share-modal-facebook-button"
                    // onClick={handleFacebookShare}
                    className="aspect-square w-14 sm:w-16 md:w-24 bg-[#d9d9d9] rounded-full flex items-center justify-center hover:bg-gray-300"
                  >
                    <img
                      id="share-modal-facebook-icon"
                      src={Facebook}
                      alt="Facebook"
                      className="w-1/2 h-1/2"
                    />
                  </button>
                </FacebookShareButton>
                <TwitterShareButton
                  url={TestshareableLink}
                  title={shareText}
                  hashtags={["insightfultraits", "personalitytest"]}
                  id="share-modal-twitter-share"
                  onClick={() => handleSocialButtonClick(SOCAIL_BUTTON.Twitter)}
                >
                  <button
                    id="share-modal-twitter-button"
                    // onClick={handleTwitterShare}
                    className="aspect-square w-14 sm:w-16 md:w-24 bg-[#d9d9d9] rounded-full flex items-center justify-center hover:bg-gray-300"
                  >
                    <span
                      className="text-2xl sm:text-3xl md:text-5xl font-medium font-['Montserrat']"
                      id="share-modal-twitter-icon"
                    >
                      𝕏
                    </span>
                  </button>
                </TwitterShareButton>
                {/* <button
                  onClick={handleTwitterShare}
                  className="aspect-square w-14 sm:w-16 md:w-24 bg-[#d9d9d9] rounded-full flex items-center justify-center hover:bg-gray-300"
                >
                  <span className="text-2xl sm:text-3xl md:text-5xl font-medium font-['Montserrat']">
                    𝕏
                  </span>
                </button> */}
                {/* <button
                  onClick={handleInstagramShare}
                  className="aspect-square w-14 sm:w-16 md:w-24 bg-[#d9d9d9] rounded-full flex items-center justify-center hover:bg-gray-300"
                >
                  <img
                    src={Instagram}
                    alt="Instagram"
                    className="w-1/2 h-1/2"
                  />
                </button> */}
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div
            className="mt-4 md:mt-8 flex-shrink-0 md:px-10"
            id="share-modal-link-section"
          >
            <div
              className="font-['Montserrat'] text-lg sm:text-xl md:text-2xl font-bold mb-2 text-center md:text-left"
              id="share-modal-link-title"
            >
              <span className="text-[#444c5e]" id="share-modal-your-text">
                {" "}
                {t("shareModal.your_text")}{" "}
              </span>
              <span
                style={{ color: personalityColorMedium }}
                id="share-modal-link-assessment-title"
              >
                {assessmentTitle}
              </span>
              <span className="text-[#444c5e]" id="share-modal-results-text">
                {" "}
                {t("shareModal.results_text")}{" "}
              </span>
            </div>
            <p
              className="text-[#444c5e] text-sm sm:text-base md:text-xl font-medium font-['Montserrat'] mb-2 text-center md:text-left"
              id="share-modal-note-text"
            >
              {t("shareModal.share_result_note")}
            </p>

            {/* Link Box */}
            <div
              className="relative flex items-center mb-2"
              id="share-modal-link-input-container"
            >
              <img
                id="share-modal-link-icon"
                src={linkIcon}
                alt="Link"
                className="absolute left-4 w-5 sm:w-6 h-5 sm:h-6 z-10"
              />
              <input
                id="share-modal-link-input"
                type="text"
                value={shareableLink}
                readOnly
                className="w-full h-12 md:h-16 bg-white rounded-lg border border-[#d9d9d9] 
                 pl-12 pr-12 text-sm sm:text-base md:text-lg font-normal font-sans 
                 truncate"
              />
              <button
                id="share-modal-copy-button"
                onClick={handleCopyLink}
                className="absolute right-4 p-1 sm:p-2 hover:bg-gray-100 rounded"
              >
                <img
                  id="share-modal-copy-icon"
                  src={copyIcon}
                  alt="Copy"
                  className="w-5 sm:w-6 h-5 sm:h-6"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareProfileModal;
